export class CookieObject {
    googleAdsGtagVariable?:string;

    googleAnalyticsGtagVariable?:string;
}
